import React, { useState } from 'react'
import { Col, Panel, Row, Table } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { delMasterUnitType, saveMasterUnitType } from '../../redux/actions/assessment'
import EditButton from '../../components/buttons/editButton/EditButton'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, DELETE_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'

import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import InputForm from '../../components/forms/input/InputForm'

export default function MasterUnitTypeWidget({ schema, ...props }) {
  const { Column, HeaderCell, Cell } = Table

  const { register, handleSubmit, errors, control, setValue, reset, clearErrors, getValues } =
    useForm()

  // const [formSchema, setFormSchema] = useState(schema)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isLoading, setIsLoading] = useState()

  const [dataList, setDataList] = useState(schema.values || [])
  const [isAddNew, setIsAddNew] = useState(false)
  const [editId, setEditId] = useState()
  const [request, setRequest] = useState()

  const [deleteId, setDeleteId] = useState()
  const [isShowDeleteConfirm, setIsShowDeleteConfirm] = useState(false)

  const [unitType, setUnitType] = useState()

  const handleCallSaveService = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsShowConfirm(false)

    try {
      const response = await saveMasterUnitType(request)
      if (response) {
        setDataList(response.values || [])
        setEditId('')
        setRequest('')
        setUnitType('')

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: response?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleCallDeleteService = async (id) => {
    setIsLoading(true)
    startLoading()
    setIsShowDeleteConfirm(false)

    try {
      const response = await delMasterUnitType(id)
      if (response) {
        setDataList(response.values || [])
        setDeleteId('')

        notification.open('success', {
          title: DELETE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: response?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('onSubmit:', data)

    let req = {
      id: editId || null,
      unitType: data.unitType,
    }

    console.log('req : ', req)
    setRequest(req)

    setIsShowConfirm(true)
  }

  const onDelete = (id) => {
    setDeleteId(id)
    setIsShowDeleteConfirm(true)
  }
  const onAdd = () => {
    setEditId('')
    setUnitType('')
    setIsAddNew(true)
  }

  const onEdit = (data) => {
    setEditId(data.id)
    setUnitType(data.name)
    setIsAddNew(true)
  }

  const onCancle = (id) => {
    setIsAddNew(false)
    setUnitType('')
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded collapsible defaultExpanded header={<b>{schema?.header || ''}</b>} bordered>
        {isAddNew ? (
          <div>
            <Row style={{ marginTop: 10 }}>
              {schema?.unitType && (
                <Col lg={24} md={24} sm={24} xs={24}>
                  <InputForm
                    schema={schema.unitType}
                    value={unitType}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    onChange={(val) => {
                      setUnitType(val)
                    }}
                  />
                </Col>
              )}
            </Row>
            <Row style={{ marginTop: 10, textAlign: 'right' }}>
              <SaveButton
                onClick={handleSubmit(onSubmit)}
                style={{ marginRight: 10, marginBottom: 10 }}
                children="บันทึก"
              />
              <CancelButton
                onClick={onCancle}
                style={{ marginRight: 10, marginBottom: 10 }}
                children="ยกเลิก"
              />
            </Row>
          </div>
        ) : (
          <div style={{ textAlign: 'right' }}>
            <SaveButton
              icon={'plus'}
              onClick={onAdd}
              style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
            >
              เพิ่มรายการ
            </SaveButton>
          </div>
        )}

        <Table autoHeight rowHeight={65} data={dataList} wordWrap>
          <Column width={80} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>
          <Column width={200} flexGrow={1}>
            <HeaderCell>ประเภทของหน่วยจัดการ</HeaderCell>
            <Cell dataKey="name" />
          </Column>

          <Column width={200} align="center" fixed="right">
            <HeaderCell>จัดการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <EditButton
                      children="แก้ไข"
                      onClick={() => {
                        onEdit(rowData)
                      }}
                      style={{
                        marginRight: 5,
                        marginBottom: 0,
                      }}
                    />
                    <CancelButton
                      children="ลบ"
                      onClick={() => {
                        onDelete(rowData.id)
                      }}
                      style={{
                        marginRight: 5,
                        marginBottom: 0,
                      }}
                      icon="trash-o"
                    />
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>

      <ConfirmWidget
        title={'ยืนยัน'}
        show={isShowConfirm}
        detail={`ยืนยันการบันทึก`}
        onCancle={() => {
          setIsShowConfirm(false)
        }}
        onConfirm={() => {
          handleCallSaveService(request)
        }}
      />

      <ConfirmWidget
        title={'ยืนยัน'}
        show={isShowDeleteConfirm}
        detail={`ยืนยันการลบ`}
        onCancle={() => {
          setIsShowDeleteConfirm(false)
        }}
        onConfirm={() => {
          handleCallDeleteService(deleteId)
        }}
      />
    </>
  )
}
